var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGreenCheckmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 44.0944C35.0457 44.0944 44 35.1209 44 24.0515C44 12.9821 35.0457 4.00854 24 4.00854C12.9543 4.00854 4 12.9821 4 24.0515C4 35.1209 12.9543 44.0944 24 44.0944Z",
    fill: "#91CF64"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.1943 15.5821C35.0065 16.2122 35.2432 17.4176 34.7268 18.3466C30.7202 25.5541 27.0745 30.3498 24.9201 32.9167C23.7614 34.2974 21.8982 34.4745 20.5843 33.2698C18.7085 31.5499 15.9516 28.63 13.3133 24.3769C12.8161 23.5754 12.9238 22.5067 13.5434 21.8136L15.132 20.0367C15.8716 19.2095 17.0873 19.1868 17.8332 20.0072C20.46 22.8968 22.4973 25.517 22.4973 25.517C22.4973 25.517 25.491 20.65 30.1398 14.749C30.7823 13.9333 31.8908 13.7954 32.6946 14.4189L34.1943 15.5821Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenCheckmark);
export default __webpack_public_path__ + "static/media/greenCheckmark.11e8f745cd3c56566c6b6bcb6051f7ec.svg";
export { ForwardRef as ReactComponent };